export enum PriceStatus {
  AVAILABLE = 'AVAILABLE',
  SOLD_OUT = 'SOLD_OUT',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  NO_PRICE = 'NO_PRICE',
  FREE = 'FREE',
}
